module.exports = __webpack_public_path__ + "static/10-2-91064d2c45d555bd286938fc5037aa56.jpg";